var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#0364b8;}.cls-3{fill:#0078d4;}.cls-4{fill:#1490df;}.cls-5{fill:#28a8ea;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OneDrive_24x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OneDrive"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.5,15l4.95-4.74A7.5,7.5,0,0,0,5.92,8C6,8,14.5,15,14.5,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.15,8.89h0A6,6,0,0,0,6,8H5.92a6,6,0,0,0-4.84,9.43L8.5,16.5l5.69-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.45,10.26h-.32a4.84,4.84,0,0,0-1.94.4h0l-3,1.26L17.5,16l5.92,1.44a4.88,4.88,0,0,0-4-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.08,17.43A6,6,0,0,0,6,20H19.13a4.89,4.89,0,0,0,4.29-2.56l-9.23-5.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedrive);
export default __webpack_public_path__ + "static/media/onedrive.0699bff07ba089f72bfeb6d06ce2ccd5.svg";
export { ForwardRef as ReactComponent };